import styled from '@emotion/styled'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead,
  Spinner,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import {
  simulateAsyncTaskCallback,
  simulateCallback
} from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import { modalSimulate } from 'Pages/WorkflowsList/recoil/state/modals'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

const StyledSpinner = styled(Spinner)`
  margin: 0 4px;
`
const StyledData = styled.span`
  margin-left: 4px;
`

export const ModalSimulate = ({ show, handleCancel }) => {
  const intl = useIntl()
  const simulate = useRecoilCallback(simulateCallback, [])
  const simulateInterval = useRecoilCallback(simulateAsyncTaskCallback, [])
  const {
    show: showModal,
    idWorkflow,
    idSimulate,
    interval,
    currentIteration,
    simulateStatus,
    simulateTotalCount,
    simulateDiscarded
  } = useRecoilValue(modalSimulate)
  const timer = useRef()

  useEffect(() => {
    showModal && simulate(idWorkflow)
  }, [show])

  useEffect(() => {
    if (
      idSimulate &&
      simulateStatus !== 'Completed' &&
      simulateStatus !== 'Error'
    ) {
      timer.current = setTimeout(() => simulateInterval(idSimulate), interval)
    }
  }, [idSimulate, currentIteration, simulateStatus])

  return (
    <Modal
      data-mu-test='modal-simulate-confirm'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ModalSimulates.Title'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.ModalSimulates.ResultPositiveFirstNew'
        })}
        <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
          {simulateTotalCount !== undefined && (
            <StyledData>{simulateTotalCount} </StyledData>
          )}
          {simulateTotalCount === undefined && <StyledSpinner />}
          {intl.formatMessage({
            id: 'Load.ModalSimulates.Contacts'
          })}
          {simulateDiscarded !== undefined && (
            <StyledData>{simulateDiscarded} </StyledData>
          )}
          {simulateDiscarded === undefined && <StyledSpinner />}
          {intl.formatMessage({
            id: 'Load.ModalSimulates.DiscardedContactsNew'
          })}
        </Text>{' '}
        {intl.formatMessage({
          id: 'Load.ModalSimulates.ResultPositiveFirstDetail'
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleCancel}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalSimulate.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func
}
